export const DEFAULT_LOCALE = 'en_US';
